import React from "react";
import _ from "lodash";
import { TableFieldBodyStyled } from "../../../NewList/styles";
import {
  CounterBodyStyled,
  CounterStopsStyled,
  CounterLoopsStyled,
  DividerStopsCountersStyled,
  DividerLoopsCountersStyled,
  StatusNameStyled,
  HoverButtonStyled,
} from "./styles";
import { deepCamelCaseKeys } from "../../../../utils/collectionUtils";
import { fetchPatchVdaAction } from "../../../../store/slices/vda_actions/actions";

import { ReactComponent as PolygonIcon } from "../../assets/polygonIcon.svg";
import { ReactComponent as RectangleItem } from "../../assets/rectangleIcon.svg";
import { ReactComponent as NoMission } from "../../assets/MissionStatuses/noMission.svg";
import { ReactComponent as CloudCheckIcon } from "../../assets/cloudCheckIcon.svg";

import { missionStatusesMap } from "./constants";

export const getStopsField = (passedStops: number, totalStops: number) => {
  const zeroPassedStops = passedStops === 0;

  return (
    <TableFieldBodyStyled>
      <CounterBodyStyled>
        <PolygonIcon />
        <CounterStopsStyled zeroCounter={zeroPassedStops}>
          {passedStops}
        </CounterStopsStyled>
      </CounterBodyStyled>
      <DividerStopsCountersStyled>Out of</DividerStopsCountersStyled>
      <CounterBodyStyled>
        <PolygonIcon />
        <CounterStopsStyled>{totalStops}</CounterStopsStyled>
      </CounterBodyStyled>
    </TableFieldBodyStyled>
  );
};

export const getVdaActionsField = (mission: any, dispatch: any) => {
  mission = deepCamelCaseKeys(mission);

  const numOfVdaActions = mission?.stops?.reduce((acc: number, curr: any) => {
    const vdaActions = _.get(curr, "vdaActions", []);
    acc += vdaActions?.length || 0;
    return acc;
  }, 0);
  const numOfVdaActionsFinished = mission?.stops?.reduce(
    (acc: number, curr: any) => {
      const vdaActions = _.get(curr, "vdaActions", []);
      acc += vdaActions?.filter(
        (vdaAction: any) => vdaAction?.actionStatus === "FINISHED"
      )?.length;
      return acc;
    },
    0
  );

  const zeroPassedActions = Number(numOfVdaActionsFinished) === 0;

  const firstActiveWaitForTriggerCloudButtonVdaAction = _.find(
    _.flatMap(mission?.stops, (stop: any) => _.get(stop, "vdaActions", [])),
    (vdaAction: any) => {
      const actionType = _.get(vdaAction, "actionType", "");
      const actionStatus = _.get(vdaAction, "actionStatus", "");
      const actionParameters = _.get(vdaAction, "actionParameters", []);
      const triggerTypeIsCloudButton = _.some(
        actionParameters,
        (parameter: any) =>
          _.get(parameter, "triggerType", "") === "CLOUD_BUTTON"
      );
      return (
        actionType === "WAIT_FOR_TRIGGER" &&
        (actionStatus === "RUNNING" ||
          actionStatus === "INITIALIZING" ||
          actionStatus === "WAITING") &&
        triggerTypeIsCloudButton
      );
    }
  );

  return (
    <TableFieldBodyStyled>
      <CounterBodyStyled>
        <PolygonIcon />
        <CounterStopsStyled zeroCounter={zeroPassedActions}>
          {numOfVdaActionsFinished}
        </CounterStopsStyled>
      </CounterBodyStyled>
      <DividerStopsCountersStyled>Out of</DividerStopsCountersStyled>
      <CounterBodyStyled>
        <PolygonIcon />
        <CounterStopsStyled>{numOfVdaActions}</CounterStopsStyled>
      </CounterBodyStyled>
      {firstActiveWaitForTriggerCloudButtonVdaAction && (
        <HoverButtonStyled
          title="Action Confirmation"
          onClick={async () => {
            await dispatch(
              fetchPatchVdaAction({
                id: firstActiveWaitForTriggerCloudButtonVdaAction.actionId,
                data: {
                  metadata: {
                    cloudButtonTriggeredAtSec: new Date().getTime() / 1000,
                  },
                },
                successMessage:
                  "Wait for trigger CLOUD_BUTTON action confirmed",
              })
            );
          }}
        >
          <CloudCheckIcon />
        </HoverButtonStyled>
      )}
    </TableFieldBodyStyled>
  );
};

export const getLoopsField = (passedLoops: number, totalLoops: number) => {
  const isInfinity = totalLoops === -1;
  const zeroPassedLoops = passedLoops === 0;

  return isInfinity ? (
    <CounterLoopsStyled zeroCounter={zeroPassedLoops} isInfinity={isInfinity}>
      {passedLoops}
    </CounterLoopsStyled>
  ) : (
    <TableFieldBodyStyled>
      <CounterLoopsStyled zeroCounter={zeroPassedLoops}>
        {passedLoops}
      </CounterLoopsStyled>
      <DividerLoopsCountersStyled>
        <RectangleItem />
      </DividerLoopsCountersStyled>
      <CounterLoopsStyled>{totalLoops}</CounterLoopsStyled>
    </TableFieldBodyStyled>
  );
};

export const getMissionStatusField = (missionStatusCode: MissionStatusCode) => {
  const { icon, statusName } = missionStatusesMap[missionStatusCode] ?? {};

  return (
    <TableFieldBodyStyled>
      {icon ?? <NoMission />}
      <StatusNameStyled>{statusName ?? missionStatusCode}</StatusNameStyled>
    </TableFieldBodyStyled>
  );
};
